export default "__VITE_ASSET__BmWp59t$__"